import { apiFetch } from "./client.js";

export interface ActivityRow {
  partitionKey: string;
  rowKey: string;
  date: string;
  type: string;
  amountCents: number;
  note: string;
  postedAt?: string;
  idempotencyKey?: string;
}

export interface ActivityResponse {
  rows: ActivityRow[];
  continuationToken: string | null;
}

export interface ListActivityOpts {
  kidId?: string;
  type?: string;
  limit?: number;
  continuationToken?: string;
}

export async function listActivity(opts: ListActivityOpts = {}): Promise<ActivityResponse> {
  const params = new URLSearchParams();
  if (opts.kidId) params.set("kidId", opts.kidId);
  if (opts.type) params.set("type", opts.type);
  if (opts.limit !== undefined) params.set("limit", String(opts.limit));
  if (opts.continuationToken) params.set("continuationToken", opts.continuationToken);
  const qs = params.toString();
  const path = `/api/activity${qs ? `?${qs}` : ""}`;
  const res = await apiFetch<{ rows: ActivityRow[]; continuationToken?: string | null }>(path);
  return { rows: res.rows, continuationToken: res.continuationToken ?? null };
}
